import React from "react";
import Input from "../../atoms/Input";
import Label from "../../atoms/Label";
import InputFieldMessage, {
  IInputFieldMessage,
} from "../../atoms/InputFieldMessage";
import { IInput } from "../../atoms/Input/Input.interface";
import { ILabel } from "../../atoms/Label/Label.types";

// TODO: refactor props and consider better props usage
export interface IInputField {
  labelProps?: ILabel;
  inputProps?: IInput;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  messageProps?: IInputFieldMessage;
  placeholder?: string;
  label?: string;
  error?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  defaultValue?: string;
  type?: string;
}

const InputField = ({
  labelProps,
  error,
  placeholder,
  inputProps,
  label,
  disabled,
  name,
  type,
  onChange,
  defaultValue,
  messageProps,
}: IInputField) => (
  <>
    <Label disabled={disabled} {...labelProps}>
      {label}
    </Label>
    <Input
      type={type}
      error={!!error}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
      {...inputProps}
      name={name}
      defaultValue={defaultValue}
    />
    <InputFieldMessage {...messageProps}>{error}</InputFieldMessage>
  </>
);

export default InputField;
